export enum NotificationEnumType {
  TASK_ASSIGNED = 'TASK_ASSIGNED',
  CAMPAIGN_FAILED = 'CAMPAIGN_FAILED',
  INBOX_CONVERSATION_ASSIGNED = 'INBOX_CONVERSATION_ASSIGNED',
  LEAD_GENERATED = 'LEAD_GENERATED',
  SECURITY = 'SECURITY',
  CONTACT_REPLIES_TO_CONVERSATION = 'CONTACT_REPLIES_TO_CONVERSATION',
  NEW_FEEDBACK_RECEIVED = 'NEW_FEEDBACK_RECEIVED',
  EMAIL_QUOTA_BELOW_THRESHOLD = 'EMAIL_QUOTA_BELOW_THRESHOLD',
  SMS_QUOTA_BELOW_THRESHOLD = 'SMS_QUOTA_BELOW_THRESHOLD',
  VOICE_QUOTA_BELOW_THRESHOLD = 'VOICE_QUOTA_BELOW_THRESHOLD',
}

export enum NotificationReadStatusEnum {
  READ = 'READ',
  UNREAD = 'UNREAD',
}
